import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/palfed': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M384.9 193.9c0.1 53.4-46.5 96.2-83.3 96.2-12.5 0-14.4-3.4-15.1-6.2 0.5-39.1 1.7-80.4 3-119.8 40.2-14.4 95.4-17.6 95.4 29.8zM190.4 266.1c-0.2-0.6-0.4-2.1-0.6-4.6 0-25.6 37-60.9 58.5-75.9-1.2 36.4-5.5 198.1-1.4 242.5 3 32.3 26.8 32.9 36.4 22.3 5.9-6.6 5.5-15.7 5.3-19.1v-0.2c-1.8-25.6-2.8-60.6-2.7-100 60.8 14.4 140.1-60.3 140.1-138.2 0-71-63-94.2-135.2-72-2.9-14.6-18.3-20.1-29.5-11.1-7.5 6.2-9.5 15.8-10.5 28.2-57.8 30.9-100.7 84.5-100.7 126.5 0 24.9 15.6 43 37.1 43 35.1 0 41-44.1 14.4-44.1-4.7 0-11 2.7-11.2 2.7zM8 181.1c0-38.6 38.4-37.4 38.4-37.4h29c15.5-70.1 120.5-74.3 120.5-74.3h28.1v-19.1c0-18.4 21.1-18.4 21.1-18.4h85.8c18.4 0 21.1 18.4 21.1 18.4v19.1h28c89.2 0 112.1 48.7 119.4 74.3h30.1c38.5 0 38.4 37.4 38.4 37.4 0 38.6-38.4 37.4-38.4 37.4h-30l-22.4 217.2c0 43.9-44.7 44.3-44.7 44.3h-288.9c-44.7 0-44.7-44.3-44.7-44.3l-22.4-217.2h-30c-38.5 0-38.4-37.4-38.4-37.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/palfed.js
// module id = 957
// module chunks = 0